const setFiltroDesde = (state, filtroDesde) => {
  state.filtroDesde = filtroDesde;
}

const setFiltroHasta = (state, filtroHasta) => {
  state.filtroHasta = filtroHasta;
}

const setFiltroEstado = (state, filtroEstado) => {
  state.filtroEstado = filtroEstado;
}

const setFiltroTipoDocumento = (state, filtroTipoDocumento) => {
  state.filtroTipoDocumento = filtroTipoDocumento;
}

const setFiltroRuc = (state, filtroRuc) => {
  state.filtroRuc = filtroRuc;
}

const setFiltroSerie = (state, filtroSerie) => {
  state.filtroSerie = filtroSerie;
}

const setFiltroNumero = (state, filtroNumero) => {
  state.filtroNumero = filtroNumero;
}
const setFiltroDesdeGuia = (state, filtroDesdeGuia) => {
  state.filtroDesdeGuia = filtroDesdeGuia;
}

const setFiltroHastaGuia = (state, filtroHastaGuia) => {
  state.filtroHastaGuia = filtroHastaGuia;
}
const setFiltroSerieGuia = (state, filtroSerieGuia) => {
  state.filtroSerieGuia = filtroSerieGuia;
}
const setFiltroTipoComprobanteGuia = (state, filtroTipoComprobanteGuia) => {
  state.filtroTipoComprobanteGuia = filtroTipoComprobanteGuia;
}

export default {
  setFiltroDesde,
  setFiltroHasta,
  setFiltroTipoDocumento,
  setFiltroRuc,
  setFiltroSerie,
  setFiltroNumero,
  setFiltroDesdeGuia,
  setFiltroHastaGuia,
  setFiltroSerieGuia,
  setFiltroEstado,
  setFiltroTipoComprobanteGuia,
};



// WEBPACK FOOTER //
// ./src/store/modules/comprobantes/mutations.js